module.exports = __webpack_public_path__ + "img/img-8-mobile.19c0ead4.webp";